// extracted by mini-css-extract-plugin
export default {"component":"b2Y9bJ","disabled":"c2Y9bJ","icon":"d2Y9bJ","iconLeft":"e2Y9bJ","iconRight":"f2Y9bJ","size-100":"g2Y9bJ","size-200":"h2Y9bJ","size-300":"i2Y9bJ","size-400":"j2Y9bJ"};